import { render } from "./Principal-certificates.vue?vue&type=template&id=71c07d11&scoped=true"
import script from "./Principal-certificates.vue?vue&type=script&lang=js"
export * from "./Principal-certificates.vue?vue&type=script&lang=js"

import "./Principal-certificates.vue?vue&type=style&index=0&id=71c07d11&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c07d11"]])

export default __exports__